var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 253.632c69.279 0 125.44-56.161 125.44-125.44S197.279 2.752 128 2.752 2.56 58.913 2.56 128.192 58.721 253.632 128 253.632Z",
    fill: "#00A64F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128 253.632c69.279 0 125.44-56.161 125.44-125.44S197.279 2.752 128 2.752 2.56 58.913 2.56 128.192 58.721 253.632 128 253.632Z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128 253.632c69.279 0 125.44-56.161 125.44-125.44S197.279 2.752 128 2.752 2.56 58.913 2.56 128.192 58.721 253.632 128 253.632Z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128 253.632c69.279 0 125.44-56.161 125.44-125.44S197.279 2.752 128 2.752 2.56 58.913 2.56 128.192 58.721 253.632 128 253.632Z",
    fill: "url(#c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150.656 118.464h-10.688V87.168h46.464v-19.2h-46.464V37.952h-23.936v30.144H105.92c-21.824 0-40.064 11.008-40.064 35.136 0 21.056 16 34.304 39.488 34.304h10.688v31.296H69.568v19.2h46.464v30.016h23.936v-30.144h10.112c21.888 0 40.064-11.008 40.064-35.136 0-21.056-16-34.304-39.488-34.304Zm-34.624 19.072v-19.072h-7.616c-10.176 0-18.432-4.288-18.432-15.68 0-11.264 7.872-15.552 18.944-15.552h7.104v31.296h23.936V137.6l-23.936-.064Zm31.04 31.296h-7.104v-31.296h7.616c10.176 0 18.432 4.288 18.432 15.68 0 11.328-7.872 15.616-18.944 15.616Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.529 197.758) scale(200.692)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#00522C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00522C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-97.18 208.446 23.352) scale(200.701)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#00A64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A64F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(244.316 46.738) scale(166.631)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#8AD137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AD137",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdp);
export default __webpack_public_path__ + "static/media/usdp.3174eeb8af747b79782285de8fb725a6.svg";
export { ForwardRef as ReactComponent };